// Topbar project nav (SPEC-404): collapsed to "back-to-home + current project name".
// The project list, inline rename/delete and new-project presets moved to the home gallery (HomeGallery.tsx).
// SPEC-406: home entry is a text button (not an icon) — same ghost-btn metrics as the project-name
// button, so the two sit at equal height in the topbar.

import { useT } from '../i18n';

export interface ProjectSwitcherProps {
  projectName: string;
  onHome: () => void;
}

export default function ProjectSwitcher({ projectName, onHome }: ProjectSwitcherProps) {
  const t = useT();
  return (
    <div className="project-switcher">
      <button className="ghost-btn" onClick={onHome}>
        {t('project.backHome')}
      </button>
      <button
        className="ghost-btn project-current"
        onClick={onHome}
        title={t('project.backHome')}
      >
        <span className="project-name">{projectName}</span>
      </button>
    </div>
  );
}
